module.exports = __webpack_public_path__ + "static/01-74441ecb7d88d3cec663d18715836b22.jpg";